import type IconNames from '@hapvida/hapvida-core-components/src/assets/icons/IconNames';
import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

export enum FinancialStatusEnum {
  // Adimplente
  Defaulting = 'Defaulting',

  // Inadimplente
  NonDefaulting = 'NonDefaulting',
}

export const FinancialStatusNames: Record<FinancialStatusEnum, string> = {
  [FinancialStatusEnum.Defaulting]: 'Adimplente',
  [FinancialStatusEnum.NonDefaulting]: 'Inadimplente',
};

export const FinancialStatusTranslate: Record<string, string> = {
  Adimplente: 'Defaulting',
  Inadimplente: 'NonDefaulting',
};

export const FinancialStatusIcons: Record<FinancialStatusEnum, IconNames> = {
  [FinancialStatusEnum.Defaulting]: 'actions-b2b-coins',
  [FinancialStatusEnum.NonDefaulting]: 'actions-b2b-close',
};

export const FinancialStatusColor: Record<FinancialStatusEnum, string> = {
  [FinancialStatusEnum.Defaulting]: NEW_COLORS.PRIMARY[600],
  [FinancialStatusEnum.NonDefaulting]: NEW_COLORS.SEMANTICS.ERROR[500],
};
